export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14706.202bd9cb.jpg";